export var Scene;
(function (Scene) {
    Scene["PASS"] = "PASS";
    Scene["PAYMENT"] = "PAYMENT";
    Scene["ATTENDANCE"] = "ATTENDANCE";
})(Scene || (Scene = {}));
export var Result;
(function (Result) {
    Result["SUCCESS"] = "SUCCESS";
    Result["FAILURE"] = "FAIL";
    Result["ACCEPT"] = "ACCEPT";
    Result["DECLINE"] = "DECLINE";
})(Result || (Result = {}));
